import Stack from '@enlighten/design-system/dist/Stack';
import Typography from '@enlighten/design-system/dist/Typography';
import React from 'react';

interface DetailToggleButtonProps {
	isOpen: boolean;
	panelId: string;
	onClick: () => void;
}

const DetailToggleButton: React.FC<DetailToggleButtonProps> = ({ isOpen, panelId, onClick }) => {
	return (
		<Stack
			component="button"
			type="button"
			aria-expanded={isOpen}
			aria-controls={panelId}
			onClick={onClick}
			alignItems="center"
			justifyContent="center"
			width="100%"
			padding="8px 16px"
			borderRadius="134px"
			sx={{ appearance: 'none', border: '1px solid #D6D7DA', bgcolor: '#FFFFFF', cursor: 'pointer' }}
		>
			<Typography fontSize="14px" fontWeight={700} lineHeight="24px" whiteSpace="nowrap">
				{isOpen ? '닫기' : '자세히보기'}
			</Typography>
		</Stack>
	);
};

export default DetailToggleButton;
